import { j as t } from "./jsx-runtime.DGlMoOmv.js";
import { T as l } from "./Text.BGhoO_e3.js";
import { T as c, c as p, b as x, a as b } from "./Tooltip.CRVGSwNn.js";
import { c as n } from "./index.CxSWpsOB.js";
const a = {
  inquired: "tw-bg-yellow-600 tw-w-[4px] tw-h-[4px] tw-rounded-full",
  requested: "tw-bg-blue-700 tw-w-[4px] tw-h-[4px] tw-rounded-full",
  offerSubmitted: "tw-bg-red-800 tw-w-[4px] tw-h-[4px] tw-rounded-full",
  booking: "tw-bg-green-800 tw-w-[4px] tw-h-[4px] tw-rounded-full"
}, m = ({
  isPartiallyBlocked: s,
  isSelectedDay: e
}) => /* @__PURE__ */ t.jsx("span", { className: n("tw-absolute tw-h-2 tw-w-16 tw-rounded-8 -tw-bottom-4 tw-bg-gray-600 tw-left-1/2 -tw-translate-x-1/2", {
  "tw-hidden": !s,
  "tw-bg-gray-700": e
}), children: /* @__PURE__ */ t.jsx("span", { className: n("tw-absolute tw-inset-0 tw-bg-gray-400 tw-rounded-tl-8 tw-rounded-bl-8 tw-hidden tw-w-1/2", {
  "tw-inline-block": s,
  "tw-bg-gray-600": e
}) }) }), j = ({
  date: s,
  activeModifiers: e
}) => {
  const o = e?.partiallyBooked && !e?.disabled && !e?.fullyBooked, r = e?.inquired, d = e?.requested, i = e?.offerSubmitted, u = e?.booking, w = /* @__PURE__ */ t.jsx("span", { className: n("tw-size-full tw-flex tw-items-center tw-justify-center", {
    "!tw-text-gray-500 tw-line-through tw-pointer-events-none": e?.fullyBooked
  }), children: /* @__PURE__ */ t.jsxs("span", { className: "tw-relative tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-1", children: [
    s.getDate(),
    /* @__PURE__ */ t.jsx(m, { isPartiallyBlocked: o, isSelectedDay: e?.selected }),
    /* @__PURE__ */ t.jsxs("div", { className: "tw-flex tw-items-start tw-gap-2 tw-absolute tw-top-16", children: [
      u && /* @__PURE__ */ t.jsx("span", { className: a.booking, title: "Booking" }, "booking-dot"),
      r && /* @__PURE__ */ t.jsx("span", { className: a.inquired, title: "Inquiry" }, "inquired-dot"),
      d && /* @__PURE__ */ t.jsx("span", { className: a.requested, title: "Request" }, "requested-dot"),
      i && /* @__PURE__ */ t.jsx("span", { className: a.offerSubmitted, title: "Offer" }, "offer-submitted-dot")
    ] })
  ] }) });
  return o ? /* @__PURE__ */ t.jsxs(c, { children: [
    /* @__PURE__ */ t.jsx(p, { asChild: !0, children: w }),
    /* @__PURE__ */ t.jsxs(x, { side: "bottom", children: [
      /* @__PURE__ */ t.jsx(l, { typeface: "body-1", className: "tw-text-gray-900", children: "Partially booked" }),
      /* @__PURE__ */ t.jsx(b, { className: "tw-fill-base-white" })
    ] })
  ] }) : w;
}, N = ({
  bookedCopy: s = "Booked",
  availableCopy: e = "Available"
}) => /* @__PURE__ */ t.jsxs("div", { className: "tw-flex tw-items-center tw-gap-16", children: [
  /* @__PURE__ */ t.jsx(l, { typeface: "caption-2", prefix: /* @__PURE__ */ t.jsx("span", { className: "tw-w-12 tw-h-2 tw-bg-purple-600 tw-rounded-8" }), children: s }),
  /* @__PURE__ */ t.jsx(l, { typeface: "caption-2", prefix: /* @__PURE__ */ t.jsx("span", { className: "tw-w-12 tw-h-2 tw-bg-gray-300 tw-rounded-8" }), children: e })
] });
export {
  j as C,
  N as a
};
//# sourceMappingURL=CalendarAvailabilityKey.BkPxKc02.js.map
